import { render, staticRenderFns } from "./ServicesInfo.vue?vue&type=template&id=6859c949&scoped=true"
import script from "./ServicesInfo.vue?vue&type=script&lang=js"
export * from "./ServicesInfo.vue?vue&type=script&lang=js"
import style0 from "./ServicesInfo.vue?vue&type=style&index=0&id=6859c949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859c949",
  null
  
)

export default component.exports